import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import EmployeeType from "./EmployeeType";
import EmployeePersonal from "./EmployeePersonal";
import EmployeeAddress from "./EmployeeAddress";
import StepsWizard from "../../../components/templates/StepsWizard";
import {
  createRecord,
  loadGlobalEmployee,
} from "../../employeeDetails/employeeDetailsSlice";
import { useHistory, useParams, useLocation } from "react-router-dom";
var unflatten = require("flat").unflatten;
var flatten = require("flat");

const NewEmployeeWizard = (props) => {
  const { hideWizard, onShowEmployeeCardClicked } = props;
  const dispatch = useDispatch();
  let location = useLocation();
  let { branchId } = useParams();
  let history = useHistory();

  const [nextDisabled, setNextDisabled] = useState(true);
  const [values, setValues] = useState({});
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const createLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/create"]
  );

  let slide2Validation = [
    "birthday",
    "first_name",
    "gender_id",
    "surename",
    "local_id_number",
  ];

  slide2Validation =
    values.is_professional_employee === "standard"
      ? slide2Validation
      : [...slide2Validation, "professional_role_id"];

  slide2Validation = branchId
    ? slide2Validation
    : [...slide2Validation, "branch"];
  const steps = [
    {
      title: null,
      description: null,
      headline: <FormattedMessage id="app.employees.staffCreationHeadline" />,
      subtitle: <FormattedMessage id="app.employees.creationSubtitle" />,
      required: ["is_professional_employee"],
      validation: ["is_professional_employee"],
      comp: <EmployeeType />,
    },
    {
      title: null,
      description: null,
      headline: null,
      subtitle: <FormattedMessage id="app.employees.personalSubtitle" />,
      required: slide2Validation,
      validation: slide2Validation,
      comp: <EmployeePersonal values={values} />,
    },
    {
      title: null,
      description: null,
      subtitle: <FormattedMessage id="app.employees.addressSubtitle" />,
      required: [],
      validation: [],
      comp: <EmployeeAddress />,
    },
  ];

  const hide = () => {
    setNextDisabled(true);
    setValues({});
    hideWizard();
  };

  const setNext = (val) => {
    setNextDisabled(val);
  };

  const isId = (value) => {
    let strId = String(value).trim();
    if (strId.length > 9 || strId.length < 8) {
      return false;
    }
    if (strId.length < 9) {
      while (strId.length < 9) strId = "0" + strId;
    }
    let counter = 0,
      rawVal,
      actualVal;
    for (let i = 0; i < strId.length; i++) {
      rawVal = Number(strId[i]) * ((i % 2) + 1);
      actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
      counter += actualVal;
    }
    if (counter % 10 === 0) {
      return true;
    } else {
      return false;
    }
  };

  const onFinish = async (formValues) => {
    const requiredFields = {
      employee_type_id: 1, //temp
      languages: [1], //temp
      staff_member: true,
    };
    const deepValues = unflatten({ ...formValues, ...requiredFields });
    const isAdmin = location.pathname.includes("admin");
    const params = {
      employee: deepValues,
      branchId: isAdmin ? values["branch"] : branchId,
    };
    const action = await dispatch(createRecord(params));
    if (!action.error) {
      hide();
      const url = isAdmin
        ? "/admin/employees/" + action.payload.data.id
        : "/branches/" + branchId + "/employees/" + action.payload.data.id;
      history.push(url);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const changeValues = (val) => {
    setValues(val);
  };
  const onValuesChange = async (changedValues, allValues) => {
    const newValues = unflatten(allValues);
    if (changedValues.local_id_number) {
      if (isId(changedValues.local_id_number)) {
        const filter = { local_id_number: changedValues.local_id_number };
        const params = {
          scopePrefix,
          filter: {
            ...filter,
          },
        };
        const action = await dispatch(loadGlobalEmployee(params));
        if (action.payload && action.payload.id) {
          const flattenRecord = flatten(action.payload, { safe: true });
          onShowEmployeeCardClicked(flattenRecord, false);
          hideWizard();
        }
      }
    }
    setValues({ ...values, ...newValues });
  };

  return (
    <StepsWizard
      formLayout={{
        labelCol: { span: 11 },
        wrapperCol: { span: 13 },
      }}
      steps={steps}
      setNext={setNext}
      changeValues={changeValues}
      values={values}
      onCancel={hide}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={hide}
      saveLoading={createLoading}
      createText={<FormattedMessage id="app.actions.addEmployee" />}
      nextDisabled={nextDisabled}
    />
  );
};

export default NewEmployeeWizard;
